import React, { useMemo } from "react";
import styles from "./LoadAssessmentSummary.module.scss";
import { DigitalLoadAssessment, PhysicalLoadAssessment } from "../../../../../model/leads/leads";

interface LoadAssessmentSummaryProps {
	assessment: PhysicalLoadAssessment | DigitalLoadAssessment;
	title?: string;
}

export const LoadAssessmentSummary: React.FC<LoadAssessmentSummaryProps> = ({
	assessment,
	title = "Load Assessment Summary"
}) => {

	const { appliances, kva, totalWatts, kwh } = useMemo(()=>{
		return assessment
	},[assessment]);
	
	if (!assessment) {
		return null;
	}

	const formatNumber = (num: number) => {
		return num.toLocaleString('en-US');
	};

	return (
		<div className={styles.container}>
			<h2 className={styles.title}>{title}</h2>
			
			<div className={styles.content}>
				<div className={styles.appliancesList}>
					{appliances.map((appliance, index) => (
						<div key={index} className={styles.applianceItem}>
							<span className={styles.applianceName}>{appliance.name}</span>
						</div>
					))}
				</div>

				<div className={styles.summaryStats}>
					<div className={styles.statItem}>
						<span className={styles.statValue}>{appliances.length} Appliances</span>
					</div>
					
					<div className={styles.statItem}>
						<span className={styles.statValue}>{formatNumber(totalWatts)} watts</span>
					</div>
					
					<div className={styles.statItem}>
						<span className={styles.statValue}>{formatNumber(kwh)} kWh</span>
					</div>
					
					<div className={styles.statItem}>
						<span className={styles.statValue}>{formatNumber(kwh)} kWh</span>
					</div>
				</div>
			</div>

			<div className={styles.kvaSection}>
				<div className={styles.kvaLabel}>
					<span>KVA Range Needed</span>
				</div>
				<div className={styles.kvaValue}>
					<span>{kva}kva to {Math.ceil(kva + 0.5)}kva</span>
				</div>
			</div>
		</div>
	);
};

export default LoadAssessmentSummary;